<template>
  <el-dialog
    class="gp-dialog"
    v-loading="loading"
    :title="title"
    :width="width"
    :visible="true"
    :top="marginTop"
    :before-close="beforeClose"
    :close-on-click-modal="true"
    :modal="modal"
    :modal-append-to-body="modalAppendToBody"
    :element-loading-text="$t('数据加载中')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <template #title>
      <slot name="title">
        <span class="el-dialog__title">{{ title }}</span>
      </slot>
    </template>

    <div style="display: contents" v-if="!loading" :key="numKey">
      <slot></slot>
    </div>

    <template #footer>
      <slot name="footer"></slot>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: String,
    container: HTMLElement,
    width: String,
    marginTop: String,
    modal: {
      type: Boolean,
      default: true
    },
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      numKey: 0
    };
  },
  methods: {
    beforeClose(done) {
      this.$destroy();
      typeof done === 'function' && done();
    },
    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
    refresh() {
      this.numKey++;
    }
  },
  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    } else {
      this.container.appendChild(this.$el);
    }
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss" scoped>
.gp-dialog {
  &-content {
    @include scrollar-style-bold;
  }
}
</style>
